import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Pasé años en Florida sintiendo que no avanzaba. Con esta guía entendí que mis dólares valían una fortuna en España. Hoy soy dueño de mi departamento y mis hijos juegan tranquilos en el parque.',
  author: 'Miguel R.',
  avatar: 'MR',
  color: '#7c6b3a'
}, {
  text: 'Tenía pánico de que el banco me quitara mi dinero si me iba. El protocolo de seguridad de esta guía fue lo que me dio la paz para dar el paso. ¡La mejor inversión que he hecho!',
  author: 'Elena G.',
  avatar: 'EG',
  color: '#5a7c6b'
}];
function StarRating() {
  return <div className="flex items-center gap-1 mb-3" data-id="element-333">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#00b67a] text-[#00b67a]" data-id="element-334" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-12 md:py-20 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-335">
      <div className="max-w-[800px] mx-auto" data-id="element-336">
        <div className="text-center mb-10 md:mb-14" data-id="element-337">
          <p className="text-[var(--accent)] text-xs font-bold tracking-widest uppercase mb-3" data-id="element-338">
            Prueba Social
          </p>
          <h2 className="text-2xl md:text-4xl font-serif text-[var(--text-heading)]" data-id="element-339">
            Historias de quienes ya dieron el paso
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-340">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[var(--bg-card)] rounded-2xl border border-[var(--border-subtle)] p-6 md:p-8 flex flex-col shadow-lg" data-id="element-341">
              <StarRating data-id="element-342" />

              <p className="text-[var(--text-primary)] text-base md:text-lg leading-relaxed flex-1 italic mb-6" data-id="element-343">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3 mt-auto pt-6 border-t border-[var(--border-subtle)]" data-id="element-344">
                <div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0" style={{
              backgroundColor: t.color
            }} data-id="element-345">
                  {t.avatar}
                </div>
                <p className="text-[var(--text-heading)] font-bold" data-id="element-346">
                  — {t.author}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}